import {
  BellIcon,
  CreditCardIcon,
  BuildingStorefrontIcon,
  FingerPrintIcon,
  UserCircleIcon,
  UsersIcon,
  DocumentMagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { SecondaryNavItem } from "./SecondaryNavigation";

export const secondaryNavigationData: SecondaryNavItem[] = [
  { name: "General", href: "/settings", icon: UserCircleIcon, current: false },
  {
    name: "Security",
    href: "/settings/security",
    icon: FingerPrintIcon,
    current: false,
  },
  {
    name: "Notifications",
    href: "/settings/notifications",
    icon: BellIcon,
    current: false,
  },
  {
    name: "Organisations",
    href: "/settings/organisations",
    icon: BuildingStorefrontIcon,
    current: false,
  },
  {
    name: "Billing",
    href: "/settings/billing",
    icon: CreditCardIcon,
    current: false,
  },
  {
    name: "Team members",
    href: "/settings/team-members",
    icon: UsersIcon,
    current: false,
  },
  {
    name: "Audit Logs",
    href: "/settings/audit-logs",
    icon: DocumentMagnifyingGlassIcon,
    current: false,
  },
];
